//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import enPwd from "./enPwd";
export default {
    mixins: [enPwd],
    data() {
        return {
            username: '',
            password: '',
            logining: false
        }
    },
    computed: {
        loginShow: {
            get() {
                return this.$store.state.loginShow;
            },
            set(value) {
                this.$store.state.loginShow = value;
            }
        }
        

    },
    methods: {
        submit() {
            if(!this.username) { this.$vux.toast.text('请输入账号'); return false; }
            if(!this.password) { this.$vux.toast.text('请输入密码'); return false; }

            this.logining = true;
            let that = this;
            var data = {
                username: that.username,
                password: that.createServerPwd(that.password)
            }
            that.$axios.post("/api/v1.0/familyApp/login", that.qs.stringify(data)).then(function (res) {
                that.logining = false;
                if(res.status == 200) {
                    that.$store.state.token = res.body.token;
                    that.$store.state.loginShow = false;
                    that.$store.state.APPPAGE.getUserInfo(1);
                }
            }).catch(function(err) {
                that.logining = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/home/login.vue